import { render, staticRenderFns } from "./ProSignUp.vue?vue&type=template&id=6018ddee"
import script from "./ProSignUp.vue?vue&type=script&lang=js"
export * from "./ProSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports